import { extendTheme } from "@chakra-ui/react";
import { MultiSelectTheme } from "chakra-multiselect";

const theme = extendTheme({
  colors: {
    brand: {
      primaryColor: "#EDF3F8",
      secondaryColor: "#52BBFF",
      lightBlue: "#B8DEF8",
      blue: "#141D43",
      royalBlue: "#3958DC",
      sage: "#A8BF87",
      blueGrey: "#464C64",
      lightSlateGrey: "#7C8298",
      white: "#FFFFFF",
      lightGreen: "#8DDE19",
      alertRed: "#ED0C0C",
      powderBlue: "#B1DFFF",
      lightPowderBlue: "#F4FAFF",
      black: "#000000",
      navyBlue: "#2272D5",
    },
    checkbox: {
      500: "#141D43",
    },
  },
  fonts: {
    heading: "montserrat",
    body: "montserrat",
  },
  components: {
    MultiSelect: MultiSelectTheme,
  },
});

export default theme;
